module.exports = __webpack_public_path__ + "static/img/label-04.8592206.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/thaipost/label-04.png
// module id = qMkK
// module chunks = 31